export const hostedCataloguesEndpoints = {
  listHostedCatalogues: { method: 'get', path: '/catalogues' },
  getHostedCatalogue: { method: 'get', path: '/catalogues/{id}' },
  createHostedCatalogue: { method: 'post', path: '/catalogues' },
  updateHostedCatalogue: { method: 'post', path: '/catalogues/{id}/update' },
  listHostedCatalogueItems: { method: 'post', path: '/catalogues/{id}/items' },
  getHostedCatalogueItem: { method: 'get', path: '/catalogues/{id}/items/{itemId}' },
  checkoutHostedCatalogue: { method: 'post', path: '/checkout' },
} as const
